module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step4-FR.292eb5e6.png";